<template>
  <div class="resource-filters">
    <p>Filter by</p>
    <slot
      v-if="!isLessThanDesktop"
      name="filters"
      :handleFiltersChange="handleFiltersChange"
    />

    <button
      v-if="isLessThanDesktop"
      class="button button--outlined mobile-filter-button"
      @click="openSheetHandler"
    >
      <span><i class="icon icon-filter icon--sm"></i> Filter</span>

      <span
        v-if="
          filtersSelected['periods'].length > 0 ||
          filtersSelected['documents'].length > 0
        "
        >{{ filteredContentLength }} result(s)</span
      >
    </button>
  </div>

  <vue-bottom-sheet ref="myBottomSheet" max-width="1200px" :full-screen="true">
    <div class="mobile-filters">
      <div class="mobile-filters__header">
        <div></div>
        <div class="mobile-filters__header-heading">
          <span class="heading-h5">Filters</span>
        </div>
        <div class="mobile-filters__header-close">
          <button
            role="button"
            aria-label="Dismiss modal"
            class="button--text button--icon base-model__header-close"
            :onClick="
              () => {
                closeSheetHandler();
              }
            "
          >
            <i class="icon icon-close icon--xs" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="mobile-filters__body">
        <slot
          v-if="isLessThanDesktop"
          name="filters"
          :handleFiltersChange="handleMobileFilterChange"
        />
      </div>
      <div class="mobile-filters__footer" v-if="isLessThanDesktop">
        <button
          role="button"
          aria-label="Dismiss modal"
          class="button button--text button--sm"
          :onClick="
            () => {
              closeSheetHandler();
            }
          "
        >
          Reset
        </button>
        <button
          role="button"
          aria-label="Dismiss modal"
          class="button button--sm"
          :disabled="!stateChanged"
          :onClick="
            () => {
              mobileUpdateFiltersHandler();
            }
          "
        >
          Update
        </button>
      </div>
    </div>
  </vue-bottom-sheet>

  <div
    v-if="
      filtersSelected['periods'].length > 0 ||
      filtersSelected['documents'].length > 0
    "
    class="
      resource-filters__active-filters
      article-filter__active-filters-container
    "
  >
    <div class="article-filter__active-filters">


      <div
        v-for="(filter, index) in filtersSelected['documents']"
        :key="index"
        class="selected-option"
      >
        {{ filter }}
        <button
          class="remove-button"
          @click="
            () => {
              handleRemoveFilter('documents', filter);
            }
          "
        >
          <i
            class="icon icon-close icon--xxs icon-color--red"
            aria-hidden="true"
          ></i>
        </button>
      </div>


      <div
        v-for="(filter, index) in filtersSelected['periods']"
        :key="index"
        class="selected-option"
      >
        {{ filter }}
        <button
          class="remove-button"
          @click="
            () => {
              handleRemoveFilter('periods', filter);
            }
          "
        >
          <i
            class="icon icon-close icon--xxs icon-color--red"
            aria-hidden="true"
          ></i>
        </button>
      </div>


      <button
        v-if="
          filtersSelected['periods'].length > 0 ||
          filtersSelected['documents'].length > 0
        "
        class="button button--text"
        @click="resetHandler"
      >
        Reset filters
      </button>
    </div>
    <div class="spacer-default"></div>
  </div>

  <slot name="filtered" :filteredContentLength="filteredContentLength" />
</template>

<script setup>
import { ref, provide, onMounted, onBeforeUnmount } from 'vue';
import { useIsBreakpointSize } from '../../hooks/useIsMobile';
import '@webzlodimir/vue-bottom-sheet/dist/style.css';
import { VueBottomSheet } from '@webzlodimir/vue-bottom-sheet';

const isLessThanDesktop = useIsBreakpointSize(991);
const filtersSelected = ref({
  documents: [],
  periods: [],
});
const tempState = ref({
  documents: [],
  periods: [],
});

const filteredContentLength = ref();
const myBottomSheet = ref(null);
const stateChanged = ref(false);

const handleMobileFilterChange = ({ name, value }) => {
  stateChanged.value = true;
  const temp = { ...filtersSelected.value };
  if (value[0] === 'all') {
    temp[name] = [];
  } else {
    temp[name] = [...value];
  }

  tempState.value = { ...temp };
};

const mobileUpdateFiltersHandler = () => {
  filtersSelected.value = { ...tempState.value };
  filterContentHandler();
  closeSheetHandler();
};

const handleFiltersChange = ({ name, value }) => {
  const temp = { ...filtersSelected.value };
  if (value[0] === 'all') {
    temp[name] = [];
  } else {
    temp[name] = [...value];
  }

  filtersSelected.value = { ...temp };
  filterContentHandler();
};

const handleRemoveFilter = (key, value) => {
  const temp = { ...filtersSelected.value };
  const index = temp[key].indexOf(value);
  if (index !== -1) {
    temp[key].splice(index, 1);
  }
  filtersSelected.value = { ...temp };
  filterContentHandler();
};

const filterContentHandler = () => {
  const filterSelectionPeriod = filtersSelected?.value?.['periods']
    ? [...filtersSelected.value['periods']]
    : [];
  const filterSelectionType = filtersSelected?.value?.['documents']
    ? [...filtersSelected.value['documents']]
    : [];

  const Accordions = Array.from(document.querySelectorAll('[data-filterable]'));
  const Cards = Array.from(document.querySelectorAll('[data-filterable]'))
    .map((accordion) => {
      return Array.from(accordion.querySelectorAll('.resource-download-card'));
    })
    .flat();
  const ListItems = Array.from(document.querySelectorAll('[data-filterable]'))
    .map((accordion) => {
      return Array.from(accordion.querySelectorAll('li'));
    })
    .flat();

  ListItems.forEach((item) => {
    if (filterSelectionType.length === 0) {
      item.style.display = 'flex';
    } else {
      const attr = item.getAttribute('data-document-type');
      const shouldShow = filterSelectionType.indexOf(attr) !== -1;
      if (shouldShow) {
        item.style.display = 'flex';
      } else {
        item.style.display = 'none';
      }
    }
  });

  Cards.forEach((item) => {
    const hasVisibleChildren = item.querySelector(
      'li[style*="display: flex;"]',
    );
    if (hasVisibleChildren) {
      item.style.display = 'block';
    } else {
      item.style.display = 'none';
    }
  });

  Accordions.forEach((item) => {
    const hasVisibleChildren = item.querySelector(
      '.resource-download-card[style*="display: block;"]',
    );
    const attr = item.getAttribute('data-period');
    const periodMatches =
      filterSelectionPeriod.length > 0
        ? filterSelectionPeriod.indexOf(attr) !== -1
        : true;

    if (hasVisibleChildren && periodMatches) {
      item.style.display = 'block';
    } else {
      item.style.display = 'none';
    }
  });
}; 

const resetHandler = () => {
  filtersSelected.value = {
    documents: [],
    periods: [],
  };
  filterContentHandler();
};

provide('injectedPeriodState', filtersSelected);
provide('injectedDocumentState', filtersSelected);

const openSheetHandler = () => {
  myBottomSheet.value.open();
  // because of how the bottom sheet destorys the component this needs to be pushed again
  filtersSelected.value = { ...filtersSelected.value };
};

const closeSheetHandler = () => {
  stateChanged.value = false;
  myBottomSheet.value.close();
};

onMounted(() => {
  window.addEventListener('resize', closeSheetHandler);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', closeSheetHandler);
});
</script>
